import { createRouter, createWebHistory } from "vue-router";
import AuthLayout from "@/components/login/AuthLayout.vue";
import LoginForm from '@/components/login/LoginForm.vue';
//import OfficeSet from "../components/portal/OfficeSet";
import PortalLayout from "../components/portal/PortalLayout";
import PasswordResetConfirmForm from "../components/login/PasswordResetConfirmForm";
import PasswordResetForm from "../components/login/PasswordResetForm";
//import MessageComponent from "../components/MessageComponent";


const routes = [ 
  {
    path: "/office-set",
    name: "OfficeSet",
    component: PortalLayout 
  },
  {
    path: "/change-office/",
    name: "ChangeOffice",
    component: PortalLayout
  },
  {
    path:"/accounts",
    component: AuthLayout,
    children: [
      {
        name: "Login",
        path: "login",
        component: LoginForm,
      },
      {
        name: "Logout",
        path: "logout",
        component: LoginForm,
      },
      {
        path: "/password-reset/",
        name: "RequestPasswordReset",
        component: PasswordResetForm
      },
      {
        path: "/password-reset/confirm/:uid/:token/",
        name: "PasswordResetConfirm",
        component: PasswordResetConfirmForm
      },
      {
        path: '/',
        redirect: {name: 'login'},
      }
    ]
  },
  /*{
    path: "/disallowed/",
    name: "DisallowedInstance",
    component: MessageComponent
  }*/
];

const router = createRouter({
  history: createWebHistory("/"),
  routes: routes
});

export default router;
